export default __webpack_public_path__ + "static/media/list-blue.becb3856.svg";